// EditScheduleModal.js

import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import '../css/EditScheduleModal.css'; // CSS za stilizaciju modala

Modal.setAppElement('#root'); // Postavite ovo ako koristite React 16 ili noviji

function EditScheduleModal({
  isOpen,
  onRequestClose,
  person,
  schedule = {},
  onSave,
  daysOfWeek,
}) {
  const [editedSchedule, setEditedSchedule] = useState({});

  useEffect(() => {
    setEditedSchedule({ ...schedule });
  }, [schedule]);

  // Funkcija za rukovanje promjenama u rasporedu
  const handleTimeSlotChange = (date, timeSlot, isChecked) => {
    setEditedSchedule((prevSchedule) => {
      const daySchedule = prevSchedule[date] || [];
      if (isChecked) {
        // Dodajemo vremenski slot
        return {
          ...prevSchedule,
          [date]: [...daySchedule, timeSlot],
        };
      } else {
        // Uklanjamo vremenski slot
        return {
          ...prevSchedule,
          [date]: daySchedule.filter((slot) => slot !== timeSlot),
        };
      }
    });
  };

  // Funkcija za spremanje promjena
  const handleSave = () => {
    onSave(editedSchedule);
    onRequestClose();
  };

  // Generiramo popis dostupnih vremenskih slotova (pretpostavljamo od 08:00 do 22:00)
  const timeSlots = Array.from({ length: 14 }, (_, i) => {
    const startHour = 8 + i;
    const endHour = startHour + 1;
    const formatTime = (hour) => `${hour.toString().padStart(2, '0')}:00`;
    return `${formatTime(startHour)} - ${formatTime(endHour)}`;
  });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Uredi Raspored"
      className="modal-content"
      overlayClassName="modal-overlay"
    >
      <h2>Uredi Raspored za {person.name}</h2>
      <div className="edit-schedule-modal">
        {daysOfWeek.map((day) => {
          const date = day.date.toISOString().split('T')[0];
          return (
            <div key={date} className="day-schedule">
              <h3>
                {day.dayName} - {date}
              </h3>
              {timeSlots.map((timeSlot) => {
                const isChecked =
                  editedSchedule[date]?.includes(timeSlot) || false;
                return (
                  <label key={timeSlot}>
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={(e) =>
                        handleTimeSlotChange(date, timeSlot, e.target.checked)
                      }
                    />
                    {timeSlot}
                  </label>
                );
              })}
            </div>
          );
        })}
      </div>
      <button onClick={handleSave}>Spremi</button>
      <button onClick={onRequestClose}>Odustani</button>
    </Modal>
  );
}

export default EditScheduleModal;
